import React from 'react';

import PropTypes from 'prop-types';

import WindowContainer from './windows/WindowContainer';

import { Route, Switch } from 'react-router';

import CarDetailScreen from './screens/CarDetailScreen';

import { CarsProvider } from './../providers/CarsProvider'

import HomeScreen from './screens/HomeScreen';

import ConfigurationDetailWindow from './windows/ConfigurationDetailWindow';

import UserDetailWindow from './windows/UserDetailWindow';

import SendBuildWindow from './windows/SendBuildWindow';

const Web = () => {

    return(
        <CarsProvider>
            <div id="web" className="cover">
                <div className="screen-container cover">
                    <Switch>
                        <Route exact={true} path="/">
                            <HomeScreen />
                        </Route>
                        <Route path="/cars/:carIdOrSlug" >
                            <CarDetailScreen />
                        </Route>
                        <Route path="/demo/:carIdOrSlug" >
                            <CarDetailScreen />
                        </Route>
                    </Switch>
                </div>
                <WindowContainer>
                    <Switch>
                        <Route exact={true} path="/cars/:carIdOrSlug/:configurationId">
                            <ConfigurationDetailWindow />
                        </Route>
                        <Route exact={true} path="/cars/:carIdOrSlug/user/:userId">
                            <UserDetailWindow />
                        </Route>
                        <Route exact={true} path="/demo/:carIdOrSlug/build/send">
                            <SendBuildWindow />
                        </Route>
                    </Switch>
                </WindowContainer>
            </div>
        </CarsProvider>
    )
}

Web.propTypes = {
    images: PropTypes.object
}

export default Web
